import React from 'react';
import { ManagerLayout, ErrorBoundary } from '@monument/core';
import { Header } from './Header';
import { Navigation } from './Navigation';
import { Route } from 'react-router';

/**
 * Specialized route component so that Layout components
 * are consistent across all routes
 */
export const AdminRoute = props => {
  const { component: RouteComponent, ...rest } = props;
  return (
    <Route
      {...rest}
      render={matchProps => {
        return (
          <ManagerLayout
            Header={<Header />}
            Navigation={<Navigation />}
            className="AdminAppLayout"
            navigationClassName="bg-green1-65"
          >
            <ErrorBoundary>
              <RouteComponent {...matchProps} {...props} />
            </ErrorBoundary>
          </ManagerLayout>
        );
      }}
    />
  );
};
